import { render, staticRenderFns } from "./TimeWheelColumn.vue?vue&type=template&id=f87cafaa&scoped=true"
import script from "./TimeWheelColumn.vue?vue&type=script&lang=js"
export * from "./TimeWheelColumn.vue?vue&type=script&lang=js"
import style0 from "./TimeWheelColumn.vue?vue&type=style&index=0&id=f87cafaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87cafaa",
  null
  
)

export default component.exports